import { render } from "./confirmModal.vue?vue&type=template&id=5c279c14&scoped=true&ts=true"
import script from "./confirmModal.vue?vue&type=script&lang=ts"
export * from "./confirmModal.vue?vue&type=script&lang=ts"

import "./confirmModal.vue?vue&type=style&index=0&id=5c279c14&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c279c14"]])

export default __exports__